export function initBackToTopButton() {
    const backToTopBtn = document.getElementById('btn-back-to-top');
    if (!backToTopBtn) return;

    backToTopBtn.style.transition = 'opacity 0.3s ease';
    backToTopBtn.style.opacity = '0';
    backToTopBtn.style.display = 'none';

    setupBackToTopScroll(backToTopBtn);
    setupBackToTopClick(backToTopBtn);
}

function setupBackToTopScroll(button) {
    let lastScrollTop = 0;
    let fadeOutTimeout = null;

    window.addEventListener('scroll', () => {
        const st = window.pageYOffset || document.documentElement.scrollTop;

        if (st === 0) {
            button.style.opacity = '0';
            setTimeout(() => {
                button.style.display = 'none';
            }, 300);
            lastScrollTop = 0;
            return;
        }

        if (st > lastScrollTop) {
            button.style.opacity = '0';
            clearTimeout(fadeOutTimeout);
            setTimeout(() => {
                button.style.display = 'none';
            }, 300);
        } else if (st < lastScrollTop) {
            if (button.style.display !== 'block') {
                button.style.display = 'block';
                button.style.opacity = '1';
            }

            clearTimeout(fadeOutTimeout);
            fadeOutTimeout = setTimeout(() => {
                button.style.opacity = '0';
                setTimeout(() => {
                    button.style.display = 'none';
                }, 300);
            }, 5000);
        }

        lastScrollTop = st <= 0 ? 0 : st;
    }, false);
}

function setupBackToTopClick(button) {
    button.addEventListener("click", () => {
        let currentScroll = window.pageYOffset;

        const smoothScroll = () => {
            const step = Math.max(currentScroll / 12, 10);
            currentScroll -= step;

            if (currentScroll > 0) {
                window.scrollTo(0, currentScroll);
                requestAnimationFrame(smoothScroll);
            } else {
                window.scrollTo(0, 0);
            }
        };

        requestAnimationFrame(smoothScroll);
    });
}



// WEBPACK FOOTER //
// ./scripts/util/backToTop.js